import { ReactNode } from 'react';

import { Box } from 'shared/ui/Box';

import styled from '@emotion/styled';

export const RootStyled = styled(Box)({
  boxSizing: 'border-box',
  width: '100%',
  color: '#18191f',
  display: 'flex',
  alignItems: 'start',
});

export const ContentStyled = styled(Box)({
  width: '100%',
  flexShrink: 0,
});

export const FormContainer = ({ children, maxWidth }: { children: ReactNode; maxWidth?: number | string }) => (
  <RootStyled>
    <ContentStyled maxWidth={maxWidth || '700px'}>{children}</ContentStyled>
  </RootStyled>
);
